// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Brand palette + PrimeReact Lara variable alignment.
 * Imported after \`primereact/.../theme.css\` so overrides apply globally.
 */
:root {
  /* Brand */
  --brand-900: #011a41;
  --brand-800: #02265e;
  --brand-700: #03347d;
  --brand-600: #0649a8;
  --brand-500: #0b63ce;
  --brand-400: #2f80ed;
  --brand-300: #6aa7f5;
  --brand-200: #acd1fb;
  --brand-100: #e6f1ff;
  --brand-50: #f3f8ff;

  /* Text */
  --text-primary: #0f172a;
  --text-secondary: #475569;
  --text-muted: #94a3b8;
  --text-on-brand: #ffffff;

  /* Background */
  --bg-page: #f5f7fb;
  --bg-card: #ffffff;
  --bg-soft: #f8fafc;
  --border: #dbe3ef;

  /* Status */
  --success: #22c55e;
  --warning: #f59e0b;
  --danger: #ef4444;
  --info: #0ea5e9;

  /* Layout / marketing surfaces */
  --gradient-brand-hero: linear-gradient(135deg, var(--brand-900) 0%, #000000 100%);
  --gradient-brand-chat: linear-gradient(135deg, var(--brand-600) 0%, var(--brand-900) 100%);
  --gradient-brand-soft: linear-gradient(135deg, var(--brand-50) 0%, var(--bg-card) 100%);

  /* ── PrimeReact Lara (light) — map to brand & semantics ───────────── */
  --primary-color: var(--brand-600);
  --primary-color-text: var(--text-on-brand);

  --primary-50: var(--brand-50);
  --primary-100: var(--brand-100);
  --primary-200: var(--brand-200);
  --primary-300: var(--brand-300);
  --primary-400: var(--brand-400);
  --primary-500: var(--brand-500);
  --primary-600: var(--brand-600);
  --primary-700: var(--brand-700);
  --primary-800: var(--brand-800);
  --primary-900: var(--brand-900);

  --text-color: var(--text-primary);
  --text-color-secondary: var(--text-secondary);

  --surface-ground: var(--bg-page);
  --surface-section: var(--bg-card);
  --surface-card: var(--bg-card);
  --surface-overlay: var(--bg-card);
  --surface-border: var(--border);
  --surface-hover: color-mix(in srgb, var(--brand-600) 6%, var(--bg-card));

  --highlight-bg: var(--brand-100);
  --highlight-text-color: var(--brand-800);

  --focus-ring: 0 0 0 0.2rem color-mix(in srgb, var(--brand-400) 32%, transparent);

  /* Prime palette “blue” scale → brand (components referencing --blue-*) */
  --blue-50: var(--brand-50);
  --blue-100: var(--brand-100);
  --blue-200: var(--brand-200);
  --blue-300: var(--brand-300);
  --blue-400: var(--brand-400);
  --blue-500: var(--brand-500);
  --blue-600: var(--brand-600);
  --blue-700: var(--brand-700);
  --blue-800: var(--brand-800);
  --blue-900: var(--brand-900);
}
`, "",{"version":3,"sources":["webpack://./src/styles/brand-tokens.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;EACE,UAAU;EACV,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;;EAEnB,SAAS;EACT,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,wBAAwB;;EAExB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;;EAEjB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;;EAEf,gCAAgC;EAChC,iFAAiF;EACjF,0FAA0F;EAC1F,uFAAuF;;EAEvF,wEAAwE;EACxE,iCAAiC;EACjC,0CAA0C;;EAE1C,6BAA6B;EAC7B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;;EAE/B,iCAAiC;EACjC,6CAA6C;;EAE7C,gCAAgC;EAChC,iCAAiC;EACjC,8BAA8B;EAC9B,iCAAiC;EACjC,+BAA+B;EAC/B,wEAAwE;;EAExE,gCAAgC;EAChC,wCAAwC;;EAExC,gFAAgF;;EAEhF,yEAAyE;EACzE,0BAA0B;EAC1B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;AAC9B","sourcesContent":["/**\n * Brand palette + PrimeReact Lara variable alignment.\n * Imported after `primereact/.../theme.css` so overrides apply globally.\n */\n:root {\n  /* Brand */\n  --brand-900: #011a41;\n  --brand-800: #02265e;\n  --brand-700: #03347d;\n  --brand-600: #0649a8;\n  --brand-500: #0b63ce;\n  --brand-400: #2f80ed;\n  --brand-300: #6aa7f5;\n  --brand-200: #acd1fb;\n  --brand-100: #e6f1ff;\n  --brand-50: #f3f8ff;\n\n  /* Text */\n  --text-primary: #0f172a;\n  --text-secondary: #475569;\n  --text-muted: #94a3b8;\n  --text-on-brand: #ffffff;\n\n  /* Background */\n  --bg-page: #f5f7fb;\n  --bg-card: #ffffff;\n  --bg-soft: #f8fafc;\n  --border: #dbe3ef;\n\n  /* Status */\n  --success: #22c55e;\n  --warning: #f59e0b;\n  --danger: #ef4444;\n  --info: #0ea5e9;\n\n  /* Layout / marketing surfaces */\n  --gradient-brand-hero: linear-gradient(135deg, var(--brand-900) 0%, #000000 100%);\n  --gradient-brand-chat: linear-gradient(135deg, var(--brand-600) 0%, var(--brand-900) 100%);\n  --gradient-brand-soft: linear-gradient(135deg, var(--brand-50) 0%, var(--bg-card) 100%);\n\n  /* ── PrimeReact Lara (light) — map to brand & semantics ───────────── */\n  --primary-color: var(--brand-600);\n  --primary-color-text: var(--text-on-brand);\n\n  --primary-50: var(--brand-50);\n  --primary-100: var(--brand-100);\n  --primary-200: var(--brand-200);\n  --primary-300: var(--brand-300);\n  --primary-400: var(--brand-400);\n  --primary-500: var(--brand-500);\n  --primary-600: var(--brand-600);\n  --primary-700: var(--brand-700);\n  --primary-800: var(--brand-800);\n  --primary-900: var(--brand-900);\n\n  --text-color: var(--text-primary);\n  --text-color-secondary: var(--text-secondary);\n\n  --surface-ground: var(--bg-page);\n  --surface-section: var(--bg-card);\n  --surface-card: var(--bg-card);\n  --surface-overlay: var(--bg-card);\n  --surface-border: var(--border);\n  --surface-hover: color-mix(in srgb, var(--brand-600) 6%, var(--bg-card));\n\n  --highlight-bg: var(--brand-100);\n  --highlight-text-color: var(--brand-800);\n\n  --focus-ring: 0 0 0 0.2rem color-mix(in srgb, var(--brand-400) 32%, transparent);\n\n  /* Prime palette “blue” scale → brand (components referencing --blue-*) */\n  --blue-50: var(--brand-50);\n  --blue-100: var(--brand-100);\n  --blue-200: var(--brand-200);\n  --blue-300: var(--brand-300);\n  --blue-400: var(--brand-400);\n  --blue-500: var(--brand-500);\n  --blue-600: var(--brand-600);\n  --blue-700: var(--brand-700);\n  --blue-800: var(--brand-800);\n  --blue-900: var(--brand-900);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
